<div class="modal fade" id="kt_modal_auction_transport_fee_add_edit" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered mw-650px">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">{{ isEditMode ? 'Update Auction Transport Fee' : 'Add Auction Transport Fee' }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <form [formGroup]="auctionTransportFeeForm" (ngSubmit)="onSubmit()" novalidate>
        <div class="modal-body p-5">
          <div class="row">
            <!-- Auction Hall -->
            <div class="col-md-12 mb-5">
              <label class="form-label required">Auction Hall</label>
              <div class="position-relative">
                <input
                  type="text"
                  class="form-control form-control-solid"
                  [(ngModel)]="auctionHallSearchTerm"
                  [ngModelOptions]="{standalone: true}"
                  (input)="onAuctionHallSearchInput($event)"
                  (focus)="onAuctionHallInputFocus()"
                  (blur)="onAuctionHallInputBlur()"
                  placeholder="Search auction halls..."
                  autocomplete="off"
                  [class.is-invalid]="auction_hall_name?.invalid && auction_hall_name?.touched"
                />

                <!-- Loading indicator -->
                <div *ngIf="isAuctionHallSearching" class="position-absolute top-50 end-0 translate-middle-y me-3">
                  <span class="spinner-border spinner-border-sm text-primary"></span>
                </div>

                <!-- Dropdown -->
                <div *ngIf="showAuctionHallDropdown" class="dropdown-menu show w-100 mt-1" style="max-height: 300px; overflow-y: auto;">
                  <div *ngIf="auctionHallSearchResults.length === 0 && !isAuctionHallSearching" class="dropdown-item-text text-muted">
                    No auction halls found
                  </div>
                  <div *ngFor="let auctionHall of auctionHallSearchResults"
                       class="dropdown-item cursor-pointer d-flex align-items-center py-3"
                       (click)="selectAuctionHall(auctionHall)">
                    <!-- Auction Hall Details -->
                    <div class="flex-grow-1">
                      <div class="fw-bold text-dark">{{ auctionHall.name || auctionHall.company_name || 'Unknown Auction Hall' }}</div>
                      <div class="text-muted fs-7" *ngIf="auctionHall.email">
                        {{ auctionHall.email }}
                      </div>
                      <div class="text-muted fs-8" *ngIf="auctionHall.phone">
                        {{ auctionHall.phone }}
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="auction_hall_name?.invalid && auction_hall_name?.touched" class="invalid-feedback">
                  <div *ngIf="auction_hall_name?.errors?.['required']">Auction hall is required</div>
                </div>
              </div>
            </div>

            <!-- Auction Fee -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Auction Fee</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="auction_fee"
                placeholder="Enter auction fee"
                min="0"
                step="1"
                [class.is-invalid]="auction_fee?.invalid && auction_fee?.touched"
              />
              <div *ngIf="auction_fee?.invalid && auction_fee?.touched" class="invalid-feedback">
                <div *ngIf="auction_fee?.errors?.['required']">Auction fee is required</div>
                <div *ngIf="auction_fee?.errors?.['min']">Auction fee must be 0 or greater</div>
              </div>
            </div>

            <!-- Transport Fee -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">Transport Fee</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="transport_fee"
                placeholder="Enter transport fee"
                min="0"
                step="1"
                [class.is-invalid]="transport_fee?.invalid && transport_fee?.touched"
              />
              <div *ngIf="transport_fee?.invalid && transport_fee?.touched" class="invalid-feedback">
                <div *ngIf="transport_fee?.errors?.['required']">Transport fee is required</div>
                <div *ngIf="transport_fee?.errors?.['min']">Transport fee must be 0 or greater</div>
              </div>
            </div>

            <!-- EAA Transport Fee -->
            <div class="col-md-4 mb-5">
              <label class="form-label required">EAA Transport Fee</label>
              <input
                type="number"
                class="form-control form-control-solid"
                formControlName="eaa_transport_fee"
                placeholder="Enter EAA transport fee"
                min="0"
                step="1"
                [class.is-invalid]="eaa_transport_fee?.invalid && eaa_transport_fee?.touched"
              />
              <div *ngIf="eaa_transport_fee?.invalid && eaa_transport_fee?.touched" class="invalid-feedback">
                <div *ngIf="eaa_transport_fee?.errors?.['required']">EAA transport fee is required</div>
                <div *ngIf="eaa_transport_fee?.errors?.['min']">EAA transport fee must be 0 or greater</div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light me-3"
            data-bs-dismiss="modal"
            [disabled]="isLoading">
            Cancel
          </button>
          <button
            type="submit"
            class="btn btn-primary"
            [disabled]="isLoading">
            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-2"></span>
            {{ isEditMode ? 'Update' : 'Add' }}
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
